module.exports = __webpack_public_path__ + "img/foto_vaga_professor.981521e5.jpg";